(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ffr-collection"]) return;
  try {
    
document.querySelectorAll('#ffr-v28-collection [data-ffr-card-url]').forEach(function(card){
  card.addEventListener('click', function(event){
    if (event.defaultPrevented) return;
    var interactive = event.target.closest('a, button, form, input, select, textarea, label');
    if (interactive) return;
    var url = card.getAttribute('data-ffr-card-url');
    if (url) window.location.href = url;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ffr-product"]) return;
  try {
    
document.querySelectorAll('[data-ffr-gallery]').forEach(function(gallery){
  var main = gallery.querySelector('[data-ffr-main]');
  var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-ffr-thumb]'));
  var index = Math.max(0, thumbs.findIndex(function(thumb){ return thumb.classList.contains('is-active'); }));
  var imageCache = new Map();
  var pendingShow = 0;
  var idle = window.requestIdleCallback || function(callback){ return window.setTimeout(callback, 80); };
  function preloadAt(preloadIndex){
    if (!thumbs.length) return Promise.resolve();
    var normalizedIndex = (preloadIndex + thumbs.length) % thumbs.length;
    var src = thumbs[normalizedIndex].dataset.src;
    var srcset = thumbs[normalizedIndex].dataset.srcset;
    var sizes = thumbs[normalizedIndex].dataset.sizes;
    if (!src) return Promise.resolve();
    var cacheKey = srcset || src;
    if (imageCache.has(cacheKey)) return imageCache.get(cacheKey);
    var image = new Image();
    image.decoding = 'async';
    if ('fetchPriority' in image) image.fetchPriority = normalizedIndex === index ? 'high' : 'low';
    if (srcset) image.srcset = srcset;
    if (sizes) image.sizes = sizes;
    var ready = new Promise(function(resolve){
      image.onload = function(){
        if (typeof image.decode === 'function') image.decode().catch(function(){}).then(resolve);
        else resolve();
      };
      image.onerror = resolve;
    });
    image.src = src;
    imageCache.set(cacheKey, ready);
    return ready;
  }
  function preloadGallery(){
    if (thumbs.length < 2) return;
    idle(function(){
      preloadAt(index + 1);
      preloadAt(index - 1);
      if (thumbs.length > 3) preloadAt(index + 2);
    });
  }
  function applyThumb(thumb){
    if (thumb.dataset.srcset) {
      main.srcset = thumb.dataset.srcset;
      main.sizes = thumb.dataset.sizes || '(min-width: 990px) 560px, 100vw';
    } else {
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
    }
    main.src = thumb.dataset.src;
    main.alt = thumb.dataset.alt || main.alt;
    thumbs.forEach(function(item){ item.classList.remove('is-active'); item.removeAttribute('aria-current'); });
    thumb.classList.add('is-active');
    thumb.setAttribute('aria-current','true');
    thumb.scrollIntoView({behavior:'auto', inline:'nearest', block:'nearest'});
  }
  function show(nextIndex){
    if (!main || !thumbs.length) return;
    var targetIndex = (nextIndex + thumbs.length) % thumbs.length;
    var token = ++pendingShow;
    index = targetIndex;
    var thumb = thumbs[index];
    main.classList.add('is-switching');
    window.requestAnimationFrame(function(){
      if (token !== pendingShow) return;
      applyThumb(thumb);
      var clearSwitching = function(){ main.classList.remove('is-switching'); };
      if (main.complete) clearSwitching();
      else {
        main.addEventListener('load', clearSwitching, { once: true });
        window.setTimeout(clearSwitching, 260);
      }
      preloadGallery();
    });
  }
  if (main && main.complete) preloadGallery();
  else if (main) main.addEventListener('load', preloadGallery, {once:true});
  thumbs.forEach(function(thumb, i){
    thumb.addEventListener('click', function(){ show(i); });
    thumb.addEventListener('pointerenter', function(){ preloadAt(i); });
    thumb.addEventListener('focus', function(){ preloadAt(i); });
  });
  var prev = gallery.querySelector('[data-ffr-prev]');
  var next = gallery.querySelector('[data-ffr-next]');
  if (prev) prev.addEventListener('click', function(event){ event.preventDefault(); event.stopPropagation(); show(index - 1); });
  if (next) next.addEventListener('click', function(event){ event.preventDefault(); event.stopPropagation(); show(index + 1); });
  var swipe = gallery.querySelector('[data-ffr-swipe]');
  var startX = 0;
  var startY = 0;
  if (swipe) {
    swipe.addEventListener('pointerdown', function(event){ startX = event.clientX; startY = event.clientY; });
    swipe.addEventListener('pointerup', function(event){
      var delta = event.clientX - startX;
      var vertical = Math.abs(event.clientY - startY);
      if (Math.abs(delta) > 26 && Math.abs(delta) > vertical * 1.15) show(delta < 0 ? index + 1 : index - 1);
    });
  }
  var zoom = gallery.querySelector('[data-ffr-zoom]');
  var lightbox = gallery.querySelector('[data-ffr-lightbox]');
  var lightboxImg = lightbox ? lightbox.querySelector('img') : null;
  var lightboxClose = lightbox ? lightbox.querySelector('[data-ffr-lightbox-close]') : null;
  var lightboxPrev = lightbox ? lightbox.querySelector('[data-ffr-lightbox-prev]') : null;
  var lightboxNext = lightbox ? lightbox.querySelector('[data-ffr-lightbox-next]') : null;
  function refreshLightbox(){
    if (!lightboxImg || !main) return;
    lightboxImg.src = main.currentSrc || main.src;
    lightboxImg.alt = main.alt || '';
  }
  if (zoom && lightbox && lightboxImg && main) {
    zoom.addEventListener('click', function(){
      refreshLightbox();
      if (typeof lightbox.showModal === 'function') {
        lightbox.showModal();
      } else {
        window.open(lightboxImg.src, '_blank');
      }
    });
    if (lightboxClose) lightboxClose.addEventListener('click', function(){ lightbox.close(); });
    lightbox.addEventListener('click', function(event){
      if (event.target === lightbox) lightbox.close();
    });
    if (lightboxPrev) lightboxPrev.addEventListener('click', function(event){ event.preventDefault(); event.stopPropagation(); show(index - 1); refreshLightbox(); });
    if (lightboxNext) lightboxNext.addEventListener('click', function(event){ event.preventDefault(); event.stopPropagation(); show(index + 1); refreshLightbox(); });
    lightbox.addEventListener('keydown', function(event){
      if (event.key === 'ArrowLeft') { show(index - 1); refreshLightbox(); }
      if (event.key === 'ArrowRight') { show(index + 1); refreshLightbox(); }
      if (event.key === 'Escape') lightbox.close();
    });
    var lightboxStartX = 0;
    lightbox.addEventListener('pointerdown', function(event){ lightboxStartX = event.clientX; });
    lightbox.addEventListener('pointerup', function(event){
      var delta = event.clientX - lightboxStartX;
      if (Math.abs(delta) > 18) { show(delta < 0 ? index + 1 : index - 1); refreshLightbox(); }
    });
  }
});
document.querySelectorAll('.ffr-form').forEach(function(form){
  var input = form.querySelector('[data-ffr-qty]');
  var minus = form.querySelector('[data-ffr-minus]');
  var plus = form.querySelector('[data-ffr-plus]');
  if (!input) return;
  if (minus) minus.addEventListener('click', function(){ input.value = Math.max(1, Number(input.value || 1) - 1); });
  if (plus) plus.addEventListener('click', function(){ input.value = Number(input.value || 1) + 1; });
});
document.querySelectorAll('[data-ffr-color-trigger]').forEach(function(trigger){
  trigger.addEventListener('click', function(event){
    event.preventDefault();
    var page = trigger.closest('.ffr-product-page');
    var firstThumb = page ? page.querySelector('[data-ffr-thumb]') : null;
    if (firstThumb) {
      firstThumb.click();
      return;
    }
    var main = page ? page.querySelector('[data-ffr-main]') : null;
    if (!main || !trigger.dataset.src) return;
    if (trigger.dataset.srcset) {
      main.srcset = trigger.dataset.srcset;
      main.sizes = trigger.dataset.sizes || '(min-width: 990px) 560px, 100vw';
    } else {
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
    }
    main.src = trigger.dataset.src;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function hideKlaviyoTeaser() {
      Array.from(document.querySelectorAll('div, span, button, a')).forEach((element) => {
        const text = (element.textContent || '').trim().replace(/\s+/g, ' ');
        if (text !== 'SIGN UP!') return;

        let node = element;
        let target = element;

        while (node && node !== document.body) {
          if (!(node instanceof HTMLElement)) break;

          const style = window.getComputedStyle(node);
          const rect = node.getBoundingClientRect();
          const className = String(node.className || '').toLowerCase();
          const testId = String(node.getAttribute('data-testid') || '').toLowerCase();

          if (
            style.position === 'fixed' ||
            className.includes('klaviyo') ||
            className.includes('kl-private') ||
            testId.includes('klaviyo') ||
            (rect.width <= 380 && rect.height <= 160 && rect.left < 120 && rect.top > window.innerHeight * 0.5)
          ) {
            target = node;
          }

          node = node.parentElement;
        }

        target.style.setProperty('display', 'none', 'important');
        target.style.setProperty('visibility', 'hidden', 'important');
        target.style.setProperty('opacity', '0', 'important');
        target.style.setProperty('pointer-events', 'none', 'important');
      });
    }

    hideKlaviyoTeaser();
    document.addEventListener('DOMContentLoaded', hideKlaviyoTeaser);
    window.addEventListener('load', hideKlaviyoTeaser);

    new MutationObserver(hideKlaviyoTeaser).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["furfreeride-home"]) return;
  try {
    
  (function () {
    const formId = 'WKeymH';

    function openKlaviyoForm(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      window._klOnsite = window._klOnsite || [];

      if (window.klaviyo && typeof window.klaviyo.openForm === 'function') {
        window.klaviyo.openForm(formId);
        return;
      }

      window._klOnsite.push(['openForm', formId]);
    }

    function bindButtons() {
      document.querySelectorAll('[data-klaviyo-open-form="WKeymH"]').forEach((button) => {
        if (button.dataset.klaviyoBound === 'true') return;
        button.dataset.klaviyoBound = 'true';
        button.addEventListener('click', openKlaviyoForm);
      });

      document.querySelectorAll('.ffr-news-form-v25').forEach((form) => {
        if (form.dataset.klaviyoBound === 'true') return;
        form.dataset.klaviyoBound = 'true';
        form.addEventListener('submit', openKlaviyoForm);
      });
    }

    bindButtons();
    document.addEventListener('DOMContentLoaded', bindButtons);
    window.addEventListener('load', bindButtons);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
